<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      unit="商家信息"
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="140px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商家编号" prop="BusiCode">
              {{ data.BusiCode }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商家全称" prop="BusiName">
              {{ data.BusiName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商家简称" prop="BusiShortname">
              {{data.BusiShortname}}
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB ? 24 : 12">
            <el-form-item label="注册日期" prop="RegTime">
              {{data.RegTime}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="登录账号" prop="RegUser">
              {{ data.RegUser }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB?24:12">
            <el-form-item label="手机号码" prop="RegPhone">
              {{ data.RegPhone }}
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="商家等级" prop="BusiGradeId">
              {{ data.GradeName }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="所在区域" prop="ShopArea">
              {{ data.DistrictNameChain }}
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系人" prop="ContactName">
              {{ data.ContactName }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系电话" prop="ContactPhone">
              {{ data.ContactPhone }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col  :span="isMB ? 24 : 12">
            <el-form-item label="商家地址" prop="ContactAddress">
              {{ data.ContactAddress }}
            </el-form-item>
          </el-col><el-col :span="isMB ? 24 : 12">
            <el-form-item label="平台分佣(%)" prop="Rate">
              {{ data.Rate }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="统一社会信用代码" prop="UnifyCode">
              {{ data.UnifyCode }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="法人代表" prop="LegalName">
              {{ data.LegalName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="主营分类" prop="typenames">
              {{ typenames }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="主营商品" prop="MainProducts">
              {{ data.MainProducts }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '营业执照'"
              :label-width="isMB ? '0' : ''"
              prop="LicensePhoto"
            >
              <el-divider v-if="isMB">营业执照</el-divider>
              <single-pic-upload
                v-model="data.LicensePhoto"
                type="LicensePhoto"
                :uploadUrl="uploadUrl"
                is-detail
              ></single-pic-upload>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '客服二维码'"
              :label-width="isMB ? '0' : ''"
              prop="QrCode"
            >
              <el-divider v-if="isMB">客服二维码</el-divider>
              <single-pic-upload
                v-model="data.QrCode"
                type="QrCode"
                :uploadUrl="uploadUrl"
                is-detail
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '商家头像'"
              :label-width="isMB ? '0' : ''"
              prop="BusiPhoto"
            >
              <el-divider v-if="isMB">商家头像</el-divider>
              <single-pic-upload
                v-model="data.BusiPhoto"
                type="BusiPhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="24">
            <el-form-item label="简介" prop="BusiInfo">
              {{data.BusiInfo}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              {{ data.OrderId }}
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              {{ data.State == 0 ? "停用" : "启用" }}
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="数据来源">
              {{ data.DataSource == 0 ? "后台添加" : "小程序申请" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12" style="padding-left: 32px">
            <div style="margin-bottom: 6px">操作日志</div>
            <el-table :data="tableData" border size="small">
              <el-table-column prop="UserName" label="操作人" />
              <el-table-column prop="OperResult" label="操作结果">
                <template slot-scope="{ row }">
                  <span v-if="row.OperResult == 1">提交</span>
                  <span v-else-if="row.OperResult == 2">通过</span>
                  <span v-else-if="row.OperResult == 3">不通过</span>
                  <span v-else-if="row.OperResult == 4">撤销审核</span>
                </template>
              </el-table-column>
              <el-table-column prop="OperDatetime" label="操作时间" />
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <template v-if="$permission.canReview()">
          <template v-if="data.CheckState == 1">
            <el-button type="success" @click="pass" :loading="isLoading"
              >通 过</el-button
            >
            <el-button type="danger" @click="noPass" :loading="isLoading"
              >不通过</el-button
            >
          </template>
          <el-button
            type="warning"
            v-else-if="data.CheckState == 2"
            @click="cancel"
            :loading="isLoading"
            >撤销审核</el-button
          >
        </template>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        BusiName: "",
        BusiShortname: "",
        BusiCode: "",
        RegUser: "",
        RegPhone: "",
        RegTime: "",
        UnifyCode: "",
        LegalName: "",
        ShopPro: "",
        ShopCity: "",
        ShopArea: "",
        DistrictId: 0,
        ContactName: "",
        ContactPhone: "",
        ContactAddress: "",
        LicensePhoto: "",
        IdentityPhoto: "",
        BusiGradeId: null,
        GradeName: "",
        DataSource: 0,
        CheckState: 0,
        DistrictNameChain: "",
        State: 1,
        Rate: "",
        QrCode: "",
        BusiPhoto:"",
        BusiType: "",
        BusiTypes: [],
        MainProducts: "",
        BusinInfo:""        
      },
      tableData: [],
      isLoading: false,
      api: require("@/api/shop/business").default,
      type_api: require("@/api/goods/typeplatform").default,
      isMB: this.$store.state.isMB,
      rules: {
        BusiName: [{ required: true, message: "商家名称不能为空" }],
        RegUser: [{ required: true, message: "注册账号不能为空" }],
        // RegPhone: [
        //   { required: true, message: "手机号码不能为空" },
        //   { validator: this.$commonJs.validateRules.validPhone },
        // ],
        ShopArea: [{ required: true, message: "请选择完整的区域" }],
        // BusiGradeId: [{ required: true, message: "商家等级不能为空" }],
        ContactPhone: [{ validator: this.$commonJs.validateRules.validPhone2 }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      types: [],
      typenames:""
    };
  },
   mounted() {
    this.type_api.list({ TypeLevel: 1 }).then((res) => {
      if (res.Code == 0) {
        this.types = res.Data;
      }
    });
  },
  methods: {
    onCreateOpened(data) {},
    onDetailsOpened(data) {
      this.loading(true);
      this.api.getChecklogs({ BusiId: this.data.RecordId }).then((res) => {
        this.loading(false);
        if (res.Code == 0) this.tableData = res.Data;
      });
      if (data.BusiType) {
        var typenames=[];
        var typeids = data.BusiType.split(",");
        typeids.forEach((element) => {
         var t= this.types.find(x=>x.RecordId==Number(element));
          if(t){
            typenames.push(t.TypeName);
          }
        });
        this.typenames=typenames.join(",");
      }
    },
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.pass(this.data.RecordId).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    noPass() {
      this.$prompt("不通过原因", "确认不通过吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.loading(true);
          this.api.noPass({Id:this.data.RecordId,CheckMsg:value}).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '取消输入'
          // });
        });
      // this.$confirm("确认不通过吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     this.loading(true);
      //       this.api.noPass(this.data.RecordId).then(res => {
      //         this.loading(false);
      //         if(res.Code==0) {
      //           this.$message.success(res.Msg);
      //           this.$emit("close-saved");
      //           this.close(true);
      //         } else {
      //           this.$message.error(res.Msg);
      //         }
      //       })
      //   })
      //   .catch(() => {});
    },
    cancel() {
      this.$confirm("确认撤销审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.cancelReview(this.data.RecordId).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    onBeforeSave() {},
    onClosed() {
      this.tableData = [];
    },
  },
};
</script>
